import { ZUid, zUid } from "src/types/zUid";
import { z } from "zod";

export const zAuditEntityState = z.object({
  username: z.string(),
  fio: z.string().nullable(), // nullable временно, пока не починят бэк
  stateId: zUid,
  timestamp: z.string(),
});
export type ZAuditEntityState = z.infer<typeof zAuditEntityState>;

export type AuditEntityStateFilters = {
  stateId?: ZUid;
  timestamp?: string[];
  userId?: ZUid;
};

export const zAuditEntityStateResponse = z.object({
  totalElements: z.number(),
  content: zAuditEntityState.array(),
});

export const zAuditUserFilter = z.object({
  userId: zUid,
  fio: z.string().nullable(),
});
export type ZAuditUserFilter = z.infer<typeof zAuditUserFilter>;
